import React, { useEffect } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";

const GeocodeLogger = () => {
  useEffect(() => {
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5000"
        : "https://address.api-bettertrucks.com";

    console.log("baseUrl", baseUrl);

    const connection = new HubConnectionBuilder()
      .withUrl(`${baseUrl}/geocodeHub`)
      .withAutomaticReconnect()
      .build();

    connection
      .start()
      .then(() => {
        console.log("Connected to SignalR hub");
        connection.on("geocodeHub", (data) => {
          console.log("Received location update:", data);
        });
      })
      .catch((err) => console.error("SignalR connection error:", err));

    return () => {
      connection.stop();
    };
  }, []);

  return <div>Listening for address validation updates... geocodeHub</div>;
};

export default GeocodeLogger;
